module.exports = __webpack_public_path__ + "img/sch1-gift2-info.af228a08.png";